export default "__VITE_ASSET__Dcy48P_X__"